import axios from "axios";
import store from "../store";

class Library {
	async archive(name, type) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/library/archive",
					{ name, type },
					{ headers: { Authorization: "Bearer " + jwt } }
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async rename(type, name, new_name) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/library/rename",
					{
						type,
						name,
						new_name,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async save(name, version, data, type, env, data_db = {}, url = false) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/library/save",
					{
						name,
						version,
						data,
						type,
						env,
						data_db,
						url
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async load(name, version = null, type) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/library/load",
					{
						name,
						version,
						type,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}

	async getby_production(type, libelle = null, data_only = false, url = false, share = true) {
		let jwt = store.state.jwt;

		// console.log("getby_production")

		var body = { type, data_only, url, share };
		if (libelle) 
			body.libelle = libelle;

		//console.log(body)

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/library/getby_production",
					body,
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					//console.log(JSON.stringify(response.data))
					resolve(response.data);
				})
				.catch(function (error) {
					console.log(error)
					reject(error);
				});
		});
	}

	async getby_libelle(name, type) {
		let jwt = store.state.jwt;

		return new Promise(function (resolve, reject) {
			axios
				.post(
					`${process.env.VUE_APP_SAAS_BACK}` + "/library/getby_libelle",
					{
						name,
						type,
					},
					{
						headers: { Authorization: "Bearer " + jwt },
					}
				)
				.then(function (response) {
					resolve(response.data);
				})
				.catch(function (error) {
					reject(error);
				});
		});
	}
}

export default new Library();
